/**
 * SONDAGE PUBLIC — /sondage-pkh?s=<session_id>&e=<email>
 * Fin de session PowerKick Her : satisfaction + témoignage optionnel.
 */
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Star, CircleNotch, CheckCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PowerKickHerSurvey() {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("s") || "";
  const email = params.get("e") || "";
  const [rating, setRating] = useState(5);
  const [recommend, setRecommend] = useState(true);
  const [testimonial, setTestimonial] = useState("");
  const [consent, setConsent] = useState(true);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/powerkick-her/public/survey`, {
        session_id: sessionId, email, name, rating,
        would_recommend: recommend, testimonial, consent_publish: consent,
      });
      setDone(true);
    } catch {
      toast.error("Une erreur est survenue, réessaie.");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6">
        <div className="text-center max-w-md" data-testid="pkh-survey-done">
          <CheckCircle size={56} weight="fill" className="text-[#D90429] mx-auto" />
          <h1 className="text-3xl font-bold mt-4">Merci ! 🥊</h1>
          <p className="text-white/60 mt-2">Ton avis compte énormément pour PowerKick Her. Au plaisir de te revoir sur le ring 💪</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6">
      <div className="w-full max-w-lg border border-white/10 bg-white/[0.03] p-8" data-testid="pkh-survey-form">
        <div className="text-center text-4xl">🥊</div>
        <h1 className="text-2xl font-bold text-center mt-2">Ta session PowerKick Her</h1>
        <p className="text-white/55 text-sm text-center mt-1">Dis-nous comment tu as vécu tes 12 semaines.</p>

        <div className="mt-6">
          <label className="text-sm text-white/70">Ta note globale</label>
          <div className="flex gap-2 mt-2" data-testid="pkh-survey-rating">
            {[1, 2, 3, 4, 5].map((n) => (
              <button key={n} onClick={() => setRating(n)} data-testid={`pkh-survey-star-${n}`} className="transition-transform hover:scale-110">
                <Star size={32} weight={n <= rating ? "fill" : "regular"} className={n <= rating ? "text-[#C9A961]" : "text-white/30"} />
              </button>
            ))}
          </div>
        </div>

        <div className="mt-5">
          <label className="text-sm text-white/70">Recommanderais-tu PowerKick Her ?</label>
          <div className="flex gap-3 mt-2">
            <button onClick={() => setRecommend(true)} data-testid="pkh-survey-reco-yes" className={`px-4 py-2 text-sm border ${recommend ? "border-[#D90429] bg-[#D90429] text-white" : "border-white/20 text-white/70"}`}>Oui, absolument</button>
            <button onClick={() => setRecommend(false)} data-testid="pkh-survey-reco-no" className={`px-4 py-2 text-sm border ${!recommend ? "border-white/60 bg-white/10" : "border-white/20 text-white/70"}`}>Pas vraiment</button>
          </div>
        </div>

        <div className="mt-5">
          <label className="text-sm text-white/70">Ton témoignage (optionnel)</label>
          <textarea value={testimonial} onChange={(e) => setTestimonial(e.target.value)} rows={4} data-testid="pkh-survey-testimonial"
            placeholder="Ce que PowerKick Her t'a apporté…" className="mt-2 w-full bg-white/5 border border-white/15 px-3 py-2 text-sm text-white outline-none focus:border-[#D90429]" />
          <input value={name} onChange={(e) => setName(e.target.value)} data-testid="pkh-survey-name"
            placeholder="Ton prénom (pour le témoignage)" className="mt-2 w-full bg-white/5 border border-white/15 px-3 py-2 text-sm text-white outline-none focus:border-[#D90429]" />
          <label className="flex items-center gap-2 mt-2 text-xs text-white/60">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="pkh-survey-consent" />
            J'autorise PowerKick Her à publier mon témoignage.
          </label>
        </div>

        <button onClick={submit} disabled={busy} data-testid="pkh-survey-submit"
          className="mt-6 w-full bg-[#D90429] text-white py-3 text-sm font-bold hover:bg-white hover:text-[#D90429] transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
          {busy ? <CircleNotch size={18} className="animate-spin" /> : null} Envoyer mon avis
        </button>
      </div>
    </div>
  );
}
